import React, { FC, useCallback, useEffect, useState } from 'react';
import { SHELL_COLORS_SESSION } from './shellColorsSession';
import './index.scss';

// Dev page to probe and pick a single --shell-* color token with live preview.
const ShellColorsPage: FC = () => {
  const { tokenName, currentHex, probeHex, isProbeActive, checkHint, options } = SHELL_COLORS_SESSION;
  const [selectedHex, setSelectedHex] = useState(isProbeActive ? probeHex : currentHex);

  // Applies the candidate color to the live CSS variable on :root.
  const applyTokenColor = useCallback(
    (hex: string) => {
      document.documentElement.style.setProperty(tokenName, hex);
      setSelectedHex(hex);
    },
    [tokenName],
  );

  useEffect(() => {
    applyTokenColor(isProbeActive ? probeHex : currentHex);
    return () => {
      document.documentElement.style.removeProperty(tokenName);
    };
  }, [applyTokenColor, currentHex, isProbeActive, probeHex, tokenName]);

  // Copies hex to clipboard for chat confirmation.
  const handleCopyHex = useCallback(() => {
    if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
      void navigator.clipboard.writeText(selectedHex);
    }
  }, [selectedHex]);

  return (
    <div className="shell-colors-page">
      <div className="shell-colors-page__intro">
        <h1 className="shell-colors-page__heading">Подбор shell-цвета</h1>
        <p className="shell-colors-page__meta">
          Токен: <span className="shell-colors-page__token">{tokenName}</span>
          {isProbeActive ? <span className="shell-colors-page__badge">probe {probeHex}</span> : null}
        </p>
        <p className="shell-colors-page__meta">
          Сейчас на странице: <code>{selectedHex}</code>
          <button type="button" className="shell-colors-page__btn" style={{ marginLeft: 8 }} onClick={handleCopyHex}>
            Скопировать hex
          </button>
        </p>
        <p className="shell-colors-page__hint">{checkHint}</p>
      </div>

      <section className="shell-colors-page__preview" aria-label="Live preview">
        <h2 className="shell-colors-page__preview-title">Preview (панель / поле / кнопки)</h2>
        <div className="shell-colors-page__preview-row">
          <div className="shell-colors-page__field">
            <label htmlFor="shell-colors-preview-input">Label</label>
            <input id="shell-colors-preview-input" type="text" placeholder="Placeholder" defaultValue="" />
          </div>
          <button type="button" className="shell-colors-page__btn">
            Main button
          </button>
          <div className="shell-colors-page__preview-chrome">
            <button type="button" className="shell-colors-page__btn-chrome">
              Chrome
            </button>
          </div>
        </div>
      </section>

      <ul className="shell-colors-page__grid">
        {options.map((option) => (
          <li key={option.id}>
            <button
              type="button"
              className={`shell-colors-page__swatch${
                selectedHex.toLowerCase() === option.hex.toLowerCase() ? ' is-selected' : ''
              }`}
              onClick={() => applyTokenColor(option.hex)}
            >
              <span className="shell-colors-page__swatch-color" style={{ backgroundColor: option.hex }} />
              <span className="shell-colors-page__swatch-meta">
                {option.label}
                <br />
                <span className="shell-colors-page__swatch-hex">{option.hex}</span>
              </span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ShellColorsPage;
